import { h } from 'preact';
import { Text } from 'preact-i18n';

// «Junior» pill next to a contestant name on start and result lists. The
// backend derives contestant.isJunior from the birth date and the race's
// juniorMaxAge (backend/lib/race-junior.js); the birth date itself is not in
// the public payload. Renders nothing unless isJunior is exactly true.
function JuniorBadge({ contestant }) {
    if (!contestant || contestant.isJunior !== true) {
        return null;
    }
    return (
        <span class='badge text-bg-info rounded-pill ms-1'>
            <Text id='race-class-contestants.junior'>Junior</Text>
        </span>
    );
}

export default JuniorBadge;
